import {
  MultiSoundStatusMap,
  SoundStatus,
} from '@/components/toggle-sound/sound-status.ts';
import {
  getPersistedState,
  persistState,
} from '@/state-utils/persisted-state.ts';
import { stopReadAloud } from '@/utils/audio-utils/read-aloud.ts';

const getStreamSoundKey = (id: string) => `stream-page-notif-sound-${id}`;

let streamNotifSoundStatus: MultiSoundStatusMap = {};

export const getStreamNotifSoundStatus = (id: string) => {
  const key = getStreamSoundKey(id);

  if (!streamNotifSoundStatus[id]) {
    const state = getPersistedState(
      key,
      SoundStatus,
      SoundStatus.off,
    ) as SoundStatus;
    streamNotifSoundStatus = { ...streamNotifSoundStatus, [id]: state };
  }

  return streamNotifSoundStatus[id];
};

export const setStreamNotifSoundStatus = (status: SoundStatus, id: string) => {
  const key = getStreamSoundKey(id);

  streamNotifSoundStatus = { ...streamNotifSoundStatus, [id]: status };
  persistState(key, status);

  if (status === SoundStatus.off) {
    stopReadAloud();
  }
};
